import { gql } from '@apollo/client';

export const EDIT_NAME_VIDEO_PARTICIPANT = gql`
  mutation EditNameVideoParticipant($testerId: ID!, $nameVideo: String!) {
    editNameVideoParticipant(testerId: $testerId, nameVideo: $nameVideo) {
      tester {
        id
      }
    }
  }
`;
